import React from "react";
import { INCOTERMS, BUYER_TYPES } from "../../mock";

const inputCls =
  "w-full bg-transparent border-b border-[#1f4a33]/25 py-3 text-[#10271a] placeholder:text-[#5e6b61]/60 focus:outline-none focus:border-[#1f4a33] transition-colors";

export default function StepDetails({ details, onChange }) {
  const update = (k) => (e) => onChange({ ...details, [k]: e.target.value });
  return (
    <div data-testid="step-details">
      <h2 className="font-display text-3xl md:text-5xl font-light leading-[1.05] text-[#10271a]">
        Who are we <em className="italic text-[#1f4a33]">building this for?</em>
      </h2>
      <p className="mt-4 text-[#5e6b61] text-lg max-w-xl">A few details so the right person on our trade desk picks this up.</p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-7">
        <Field label="Company" required><input className={inputCls} value={details.company} onChange={update("company")} placeholder="Company name" data-testid="details-company" /></Field>
        <Field label="Contact name" required><input className={inputCls} value={details.name} onChange={update("name")} placeholder="Your name" data-testid="details-name" /></Field>
        <Field label="Email" required><input className={inputCls} type="email" value={details.email} onChange={update("email")} placeholder="you@company.com" data-testid="details-email" /></Field>
        <Field label="Phone"><input className={inputCls} value={details.phone} onChange={update("phone")} placeholder="+44 ..." data-testid="details-phone" /></Field>
        <Field label="Destination country" required><input className={inputCls} value={details.country} onChange={update("country")} placeholder="e.g. United Kingdom" data-testid="details-country" /></Field>
        <Field label="Destination port / city"><input className={inputCls} value={details.port} onChange={update("port")} placeholder="e.g. Felixstowe" data-testid="details-port" /></Field>
        <Field label="Buyer type">
          <select className={`${inputCls} appearance-none`} value={details.buyerType} onChange={update("buyerType")} data-testid="details-buyer-type">
            {BUYER_TYPES.map((b) => <option key={b}>{b}</option>)}
          </select>
        </Field>
        <Field label="Preferred terms">
          <select className={`${inputCls} appearance-none`} value={details.incoterm} onChange={update("incoterm")} data-testid="details-incoterm">
            {INCOTERMS.map((t) => <option key={t}>{t}</option>)}
          </select>
        </Field>
      </div>
      <div className="mt-7">
        <Field label="Anything else">
          <textarea className={`${inputCls} resize-none`} rows={3} value={details.notes} onChange={update("notes")} placeholder="Certifications, cupping samples, target timing..." data-testid="details-notes" />
        </Field>
      </div>
    </div>
  );
}

function Field({ label, required, children }) {
  return (
    <label className="block">
      <span className="text-[11px] tracking-[0.18em] uppercase text-[#5e6b61]">
        {label}{required && <span className="text-[#7c5230]"> *</span>}
      </span>
      {children}
    </label>
  );
}
